// 路由配置
import { Suspense, useEffect } from 'react';
import Layout from '@/layout';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import NoPage from '@/layout/components/404';
import Navigation from '@/layout/components/Navigation';
import Loading from '@/common/components/Map/components/Loading';
import V1Spin from '@/common/components/Feedback/V1Spin';
// import CustomSkeleton from '@/common/components/Business/CustomSkeleton';
import RouterControl from './router/control'; // 路由守卫
// 移动端动画坑多，先注释掉了
// import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { routersConfig } from '@/router/router';
import { onNavigate } from './common/document-event/on';
import { urlParams } from '@lhb/func';
import { setCookie } from '@lhb/cache';
import { useTenantCheckInfo } from './common/hooks/useTenantCheckInfo';
import { useMethods } from '@lhb/hook';
import { useDispatch } from 'react-redux';
import { getHeader } from './common/request/utils';
import { getGlobalSpecialConfig } from './ka-global-config';
import { fetchBotStoreCurrent } from './views/abside/store';
import { shouldSyncViewportHeight } from './common/utils/viewport';

const routeList = routersConfig(); // 不能在jsx内执行，需要在Main函数之前就调用，才能获取到正确的页面组件
const targetUrl = [
  '/insight/map', // 周边查询地图
  '/storemap/universal', // 门店地图
  '/collection/businessmap', // 集客点地图
  '/storemap', // 鱼你的门店地图
];

const isDev = process.env.NODE_ENV === 'development';
const inRN = !!(window as any).ReactNativeWebView; // 是否在RN环境内
const Main = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const path = window.location.pathname;
  const isMapPage = targetUrl.includes(path);

  const { getTenantCheckInfo } = useTenantCheckInfo({ immediate: false });

  useEffect(() => {
    onNavigate(navigate);
    // 插入 100vh 兼容 --vh
    methods.setViewportHeight();
    window.addEventListener('resize', methods.handleViewportResize);
    window.visualViewport?.addEventListener('resize', methods.handleViewportResize);

    const { token } = urlParams(location.search);
    if (token) {
      setCookie('flow_token', token);
    }
    if (inRN) {
      if (!document.body.classList.contains('body-in-rn')) {
        document.body.classList.add('body-in-rn');
      }
    }

    methods.init();

    return () => {
      window.removeEventListener('resize', methods.handleViewportResize);
      window.visualViewport?.removeEventListener('resize', methods.handleViewportResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const methods = useMethods({

    /** 同步当前可视区域高度，兼容微信 WebView 与浏览器动态工具栏。 */
    setViewportHeight() {
      const height = window.visualViewport?.height || window.innerHeight;
      document.documentElement.style.setProperty('--vh', `${height * 0.01}px`);
    },

    /** 输入控件聚焦时，忽略软键盘引起的视口高度变化。 */
    handleViewportResize() {
      if (!shouldSyncViewportHeight(document.activeElement as HTMLElement | null)) {
        return;
      }
      methods.setViewportHeight();
    },

    init() {
      methods.initGetTenantCheckInfo();
    },

    initAbsideCurrentStore() {
      if (/^\/abside(?:\/|$)/.test(location.pathname)) {
        dispatch(fetchBotStoreCurrent() as any);
      }
    },

    /** 检查是否有 token */
    async checkHasToken() {
      // 获取逻辑复用请求接口时的逻辑
      const config: any = await getHeader();
      return !!config.token;
    },

    /** 初始化立即获取一次当前租户的检查信息（含拓店模板） */
    async initGetTenantCheckInfo() {

      /** 以下页面不请求 */
      const ignoreRoute = ['/share/youth', '/share/store'];
      if (ignoreRoute.includes(path)) {
        return;
      }

      /** 保险方法，需要请求的路由才进行请求 */
      const needRequestRoute = [
        /\/home\/?.*/,
        /\/insight\/?.*/,
        /\/iterate\/?.*/,
        /\/sitemap\/?.*/,
        /\/spotevaluation\/?.*/,
        /\/standardstore\/?.*/,
        /\/storemap\/?.*/,
      ];
      try {
        if (needRequestRoute.some((item) => item.test(path))) {
          // 有 token 才请求接口；防止某些页面不需要请求
          if (await methods.checkHasToken()) {
            getTenantCheckInfo(true);
          }
        }
      } catch (error) {
        console.log('error', error);
      }
    },
  });

  useEffect(methods.initAbsideCurrentStore, [location.pathname]);

  return (
    <RouterControl locationTo={location} routeList={routeList}>
      <Layout>
        {/* <TransitionGroup component={null}> */}
        {/* <CSSTransition key={location.key} classNames='fade' timeout={300}> */}
        {/* <div> */}
        <Suspense fallback={isMapPage ? <Loading/> : <V1Spin fullscreen style={{
          backgroundColor: 'rgb(245, 245, 245)'
        }}/>}>
          <Routes location={location}>
            {routeList.map((item) => (
              <Route
                key={item.path}
                path={item.path}
                element={
                  <item.component
                    location={location}
                    globalSpecialConfig={getGlobalSpecialConfig()}
                  />
                }>
              </Route>
            ))}
            {/* 匹配找不到的路由 */}
            <Route path='*' element={isDev ? <Navigation/> : <NoPage />}></Route>
          </Routes>
        </Suspense>
        {/* </div> */}
        {/* </CSSTransition>
          </TransitionGroup> */}
      </Layout>
    </RouterControl>
  );
};

export default Main;
